import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    content: {
      padding: "8px 16px",
    },
    formControl: (props) => ({
      minWidth: props.isMobile ? "auto" : 410,
      width: "100%",
    }),
  }),
);

export default useStyles;
